// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"index_sectionHeader__3CUvM","sectionPanelHeader":"index_sectionPanelHeader__3XeVd","title":"index_title__3z6bg","issuesTag":"index_issuesTag__1sz9N"};